export default __webpack_public_path__ + "static/media/noNotificationsFound.2d0777f1.svg";